import { render } from "./ProductsGrid.vue?vue&type=template&id=0240d226&scoped=true"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=0240d226&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0240d226"

export default script